import * as React from "react";
import { useTranslation } from "react-i18next";
import { Switch } from "@headlessui/react";

import { useServiceWorker } from "../../context/ServiceWorkerContext";

import PushNotificationsModal from "./PushNotificationsModal";

interface Props {
  text: string;
  checked: boolean;
  onChange: (allowed: boolean) => void;
}

const PushNotificationsSwitch: React.FC<Props> = ({
  text, checked, onChange,
}) => {
  const { t } = useTranslation("common");
  const { loadingPush, pushSupported } = useServiceWorker();

  return (!loadingPush && pushSupported) ? (
    <Switch.Group>
      {checked && <PushNotificationsModal onClose={onChange} />}
      <div className="flex gap-6 items-start pb-6">
        <div className="grow flex flex-col">
          <Switch.Label className="mr-4">{t("notifications.push.title")}</Switch.Label>
          <div className="text-xs text-slate-500">{text}</div>
        </div>
        <div className="justify-self-end mr-6">
          <Switch
            checked={checked}
            onChange={onChange}
            className={`${checked ? "bg-blue-600" : "bg-blue-200"} relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
          >
            <span
              className={`${
                checked ? "translate-x-6" : "translate-x-1"
              } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
            />
          </Switch>
        </div>
      </div>
    </Switch.Group>
  ) : <></>;
};

export default PushNotificationsSwitch;
